import { BaseModel } from './base-model';

export class AddressModel extends BaseModel {
  addressLines: string[];
  state: string;
  locality: string;
  postalCode: string;
  country: string;
}
